// extracted by mini-css-extract-plugin
export default {"popup":"MapPopup_popup__+8JqZ","totalAmount":"MapPopup_totalAmount__xwpaE","refPopup":"MapPopup_refPopup__OiesQ"};